(function(){
  var els = document.querySelectorAll('[data-al-reveal]');
  if (!('IntersectionObserver' in window)) { els.forEach(function(e){ e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  function observe(root){ (root || document).querySelectorAll('[data-al-reveal]:not(.is-in)').forEach(function(e){ io.observe(e); }); }
  observe();
  document.addEventListener('shopify:section:load', function(e){ observe(e.target); e.target.querySelectorAll('[data-al-reveal]').forEach(function(x){ x.classList.add('is-in'); }); });
})();
/* Start marquees only after the visitor interacts, and only while they are on screen */
(function(){
  var strips = document.querySelectorAll('.al-marquee');
  if (!strips.length) return;
  var interacted = false, visible = new Set();
  function sync(){ strips.forEach(function(s){ s.classList.toggle('is-on', interacted && visible.has(s)); }); }
  function go(){ if (interacted) return; interacted = true; sync(); }
  ['scroll','pointerdown','touchstart','keydown','mousemove'].forEach(function(e){ window.addEventListener(e, go, { once: true, passive: true }); });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ e.isIntersecting ? visible.add(e.target) : visible.delete(e.target); }); sync(); });
    strips.forEach(function(s){ io.observe(s); });
  } else { strips.forEach(function(s){ visible.add(s); }); }
  if (window.Shopify && Shopify.designMode) { interacted = true; strips.forEach(function(s){ visible.add(s); }); sync(); }
})();